import { Helmet } from "react-helmet-async";

const Datenschutz = () => {
  return (
    <>
      <Helmet>
        <title>Datenschutzerklärung - EIGENHEIMVERRENTUNG</title>
        <meta name="description" content="Datenschutzerklärung von EIGENHEIMVERRENTUNG - Informationen zum Schutz Ihrer persönlichen Daten gemäß DSGVO." />
        <meta name="keywords" content="datenschutz, dsgvo, privatsphäre, cookies, eigenheimverrentung, datenschutzerklärung" />
        <link rel="canonical" href="https://eigenheimverrentung.de/datenschutz" />
        <meta name="robots" content="noindex, follow" />
        <meta name="googlebot" content="noindex, follow" />
      </Helmet>
      
      <div className="min-h-screen bg-gradient-to-br from-background to-muted/20">
        <div className="container mx-auto px-4 py-16">
          <div className="max-w-4xl mx-auto">
            <header className="text-center mb-12">
              <h1 className="text-4xl md:text-5xl font-bold text-primary mb-4">
                Datenschutzerklärung
              </h1>
              <div className="w-24 h-1 bg-accent mx-auto rounded-full"></div>
            </header>

            <div className="bg-card rounded-2xl shadow-lg border p-8 md:p-12 space-y-8">
              <div className="space-y-8 text-foreground">
                
                <section>
                  <h2 className="text-2xl font-semibold mb-4 text-primary">1. Datenschutz auf einen Blick</h2>
                  
                  <h3 className="text-xl font-medium mb-3">Allgemeine Hinweise</h3>
                  <p className="mb-4 text-muted-foreground">
                    Die folgenden Hinweise geben einen einfachen Überblick darüber, was mit Ihren personenbezogenen Daten passiert, wenn Sie diese Website besuchen. Personenbezogene Daten sind alle Daten, mit denen Sie persönlich identifiziert werden können. Ausführliche Informationen zum Thema Datenschutz entnehmen Sie unserer unter diesem Text aufgeführten Datenschutzerklärung.
                  </p>

                  <h3 className="text-xl font-medium mb-3">Datenerfassung auf dieser Website</h3>
                  <p className="mb-4 text-muted-foreground">
                    <strong>Wer ist verantwortlich für die Datenerfassung auf dieser Website?</strong><br />
                    Die Datenverarbeitung auf dieser Website erfolgt durch den Websitebetreiber. Dessen Kontaktdaten können Sie dem Impressum dieser Website entnehmen.
                  </p>
                  <p className="mb-4 text-muted-foreground">
                    <strong>Wie erfassen wir Ihre Daten?</strong><br />
                    Ihre Daten werden zum einen dadurch erhoben, dass Sie uns diese mitteilen. Hierbei kann es sich z. B. um Daten handeln, die Sie in ein Kontaktformular eingeben.
                  </p>
                  <p className="mb-4 text-muted-foreground">
                    Andere Daten werden automatisch oder nach Ihrer Einwilligung beim Besuch der Website durch unsere IT-Systeme erfasst. Das sind vor allem technische Daten (z. B. Internetbrowser, Betriebssystem oder Uhrzeit des Seitenaufrufs). Die Erfassung dieser Daten erfolgt automatisch, sobald Sie diese Website betreten.
                  </p>
                </section>

                <section>
                  <h2 className="text-2xl font-semibold mb-4 text-primary">2. Hosting und Content Delivery Networks (CDN)</h2>
                  
                  <h3 className="text-xl font-medium mb-3">Externes Hosting</h3>
                  <p className="mb-4 text-muted-foreground">
                    Diese Website wird bei einem externen Dienstleister gehostet (Hoster). Die personenbezogenen Daten, die auf dieser Website erfasst werden, werden auf den Servern des Hosters gespeichert. Hierbei kann es sich v. a. um IP-Adressen, Kontaktanfragen, Meta- und Kommunikationsdaten, Vertragsdaten, Kontaktdaten, Namen, Webseitenzugriffe und sonstige Daten, die über eine Website generiert werden, handeln.
                  </p>
                  <p className="mb-4 text-muted-foreground">
                    Der Einsatz des Hosters erfolgt zum Zwecke der Vertragserfüllung gegenüber unseren potenziellen und bestehenden Kunden (Art. 6 Abs. 1 lit. b DSGVO) und im Interesse einer sicheren, schnellen und effizienten Bereitstellung unseres Online-Angebots durch einen professionellen Anbieter (Art. 6 Abs. 1 lit. f DSGVO).
                  </p>
                </section>

                <section>
                  <h2 className="text-2xl font-semibold mb-4 text-primary">3. Allgemeine Hinweise und Pflichtinformationen</h2>
                  
                  <h3 className="text-xl font-medium mb-3">Datenschutz</h3>
                  <p className="mb-4 text-muted-foreground">
                    Die Betreiber dieser Seiten nehmen den Schutz Ihrer persönlichen Daten sehr ernst. Wir behandeln Ihre personenbezogenen Daten vertraulich und entsprechend der gesetzlichen Datenschutzbestimmungen sowie dieser Datenschutzerklärung.
                  </p>
                  <p className="mb-4 text-muted-foreground">
                    Wenn Sie diese Website benutzen, werden verschiedene personenbezogene Daten erhoben. Personenbezogene Daten sind Daten, mit denen Sie persönlich identifiziert werden können. Die vorliegende Datenschutzerklärung erläutert, welche Daten wir erheben und wofür wir sie nutzen. Sie erläutert auch, wie und zu welchem Zweck das geschieht.
                  </p>

                  <h3 className="text-xl font-medium mb-3">Hinweis zur verantwortlichen Stelle</h3>
                  <p className="mb-4 text-muted-foreground">
                    Die verantwortliche Stelle für die Datenverarbeitung auf dieser Website ist:
                  </p>
                  <div className="bg-muted/30 p-4 rounded-lg mb-4">
                    <p className="font-medium">RPI GmbH</p>
                    <p>Gotthelfstraße 36</p>
                    <p>81677 München</p>
                    <p>Deutschland</p>
                    <p className="mt-2">
                      Telefon: 08962824646<br />
                      E-Mail: <a href="mailto:info@renteplusimmobilie.de" className="text-accent hover:underline">info@renteplusimmobilie.de</a>
                    </p>
                  </div>
                  <p className="mb-4 text-muted-foreground">
                    Verantwortliche Stelle ist die natürliche oder juristische Person, die allein oder gemeinsam mit anderen über die Zwecke und Mittel der Verarbeitung von personenbezogenen Daten (z. B. Namen, E-Mail-Adressen o. Ä.) entscheidet.
                  </p>
                </section>

                <section>
                  <h2 className="text-2xl font-semibold mb-4 text-primary">4. Datenerfassung auf dieser Website</h2>
                  
                  <h3 className="text-xl font-medium mb-3">Server-Log-Dateien</h3>
                  <p className="mb-4 text-muted-foreground">
                    Der Provider der Seiten erhebt und speichert automatisch Informationen in so genannten Server-Log-Dateien, die Ihr Browser automatisch an uns übermittelt. Dies sind:
                  </p>
                  <ul className="list-disc ml-6 mb-4 text-muted-foreground space-y-1">
                    <li>Browsertyp und Browserversion</li>
                    <li>verwendetes Betriebssystem</li>
                    <li>Referrer URL</li>
                    <li>Hostname des zugreifenden Rechners</li>
                    <li>Uhrzeit der Serveranfrage</li>
                    <li>IP-Adresse</li>
                  </ul>
                  <p className="mb-4 text-muted-foreground">
                    Eine Zusammenführung dieser Daten mit anderen Datenquellen wird nicht vorgenommen.
                  </p>

                  <h3 className="text-xl font-medium mb-3">Kontaktformular</h3>
                  <p className="mb-4 text-muted-foreground">
                    Wenn Sie uns per Kontaktformular Anfragen zukommen lassen, werden Ihre Angaben aus dem Anfrageformular inklusive der von Ihnen dort angegebenen Kontaktdaten zwecks Bearbeitung der Anfrage und für den Fall von Anschlussfragen bei uns gespeichert. Diese Daten geben wir nicht ohne Ihre Einwilligung weiter.
                  </p>
                  <p className="mb-4 text-muted-foreground">
                    Die Verarbeitung dieser Daten erfolgt auf Grundlage von Art. 6 Abs. 1 lit. b DSGVO, sofern Ihre Anfrage mit der Erfüllung eines Vertrags zusammenhängt oder zur Durchführung vorvertraglicher Maßnahmen erforderlich ist. In allen übrigen Fällen beruht die Verarbeitung auf unserem berechtigten Interesse an der effektiven Bearbeitung der an uns gerichteten Anfragen (Art. 6 Abs. 1 lit. f DSGVO) oder auf Ihrer Einwilligung (Art. 6 Abs. 1 lit. a DSGVO) sofern diese abgefragt wurde.
                  </p>
                </section>

                <section>
                  <h2 className="text-2xl font-semibold mb-4 text-primary">5. Analyse-Tools und Werbung</h2>
                  
                  <h3 className="text-xl font-medium mb-3">Calendly</h3>
                  <p className="mb-4 text-muted-foreground">
                    Wir nutzen auf unserer Website den Terminbuchungsservice Calendly der Calendly LLC, 271 17th St NW, Fl 10, Atlanta, GA 30363, USA. Calendly ermöglicht es Ihnen, direkt über unsere Website Beratungstermine zu vereinbaren.
                  </p>
                  <p className="mb-4 text-muted-foreground">
                    Bei der Nutzung von Calendly werden personenbezogene Daten wie Name, E-Mail-Adresse und Telefonnummer an Calendly übertragen und dort verarbeitet. Die Rechtsgrundlage für diese Datenverarbeitung ist Art. 6 Abs. 1 lit. b DSGVO (Vertragserfüllung) bzw. Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse an der effizienten Terminverwaltung).
                  </p>
                  <p className="mb-4 text-muted-foreground">
                    Weitere Informationen finden Sie in der Datenschutzerklärung von Calendly: 
                    <a 
                      href="https://calendly.com/privacy" 
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="text-accent hover:underline ml-1"
                    >
                      https://calendly.com/privacy
                    </a>
                  </p>
                </section>

                <section>
                  <h2 className="text-2xl font-semibold mb-4 text-primary">6. Ihre Rechte</h2>
                  <p className="mb-4 text-muted-foreground">
                    Sie haben folgende Rechte bezüglich Ihrer personenbezogenen Daten:
                  </p>
                  <ul className="list-disc ml-6 mb-4 text-muted-foreground space-y-2">
                    <li><strong>Recht auf Auskunft:</strong> Sie können eine Bestätigung darüber verlangen, ob personenbezogene Daten verarbeitet werden.</li>
                    <li><strong>Recht auf Berichtigung:</strong> Sie haben das Recht, unverzüglich die Berichtigung Sie betreffender unrichtiger personenbezogener Daten zu verlangen.</li>
                    <li><strong>Recht auf Löschung:</strong> Sie haben das Recht, die Löschung Sie betreffender personenbezogener Daten zu verlangen.</li>
                    <li><strong>Recht auf Einschränkung der Verarbeitung:</strong> Sie haben das Recht, die Einschränkung der Verarbeitung zu verlangen.</li>
                    <li><strong>Recht auf Datenübertragbarkeit:</strong> Sie haben das Recht, die Sie betreffenden personenbezogenen Daten in einem strukturierten Format zu erhalten.</li>
                    <li><strong>Widerspruchsrecht:</strong> Sie haben das Recht, jederzeit gegen die Verarbeitung Sie betreffender personenbezogener Daten Widerspruch einzulegen.</li>
                  </ul>
                </section>

                <section>
                  <h2 className="text-2xl font-semibold mb-4 text-primary">7. SSL- bzw. TLS-Verschlüsselung</h2>
                  <p className="mb-4 text-muted-foreground">
                    Diese Seite nutzt aus Sicherheitsgründen und zum Schutz der Übertragung vertraulicher Inhalte, wie zum Beispiel Bestellungen oder Anfragen, die Sie an uns als Seitenbetreiber senden, eine SSL- bzw. TLS-Verschlüsselung. Eine verschlüsselte Verbindung erkennen Sie daran, dass die Adresszeile des Browsers von „http://" auf „https://" wechselt und an dem Schloss-Symbol in Ihrer Browserzeile.
                  </p>
                  <p className="mb-4 text-muted-foreground">
                    Wenn die SSL- bzw. TLS-Verschlüsselung aktiviert ist, können die Daten, die Sie an uns übermitteln, nicht von Dritten mitgelesen werden.
                  </p>
                </section>

                <section>
                  <h2 className="text-2xl font-semibold mb-4 text-primary">8. Kontakt bei Datenschutzfragen</h2>
                  <p className="mb-4 text-muted-foreground">
                    Wenn Sie Fragen zum Datenschutz haben, schreiben Sie uns bitte eine E-Mail oder wenden Sie sich direkt an die für den Datenschutz verantwortliche Person in unserer Organisation:
                  </p>
                  <div className="bg-muted/30 p-4 rounded-lg mb-6">
                    <p className="font-medium">RPI GmbH</p>
                    <p>Datenschutzbeauftragter</p>
                    <p>E-Mail: <a href="mailto:info@renteplusimmobilie.de" className="text-accent hover:underline">info@renteplusimmobilie.de</a></p>
                  </div>
                </section>

                <div className="pt-8 border-t">
                  <h2 className="text-xl font-semibold mb-4 text-primary">Kostenlose Beratung vereinbaren</h2>
                  <p className="text-muted-foreground mb-6">
                    Haben Sie Fragen zur Immobilienverrentung? Vereinbaren Sie jetzt Ihren kostenlosen Beratungstermin.
                  </p>
                  <a
                    href="https://calendly.com/renteplusimmobilie/20min"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-block bg-accent hover:bg-accent/90 text-accent-foreground px-6 py-3 rounded-lg font-medium transition-colors"
                  >
                    Beratungstermin vereinbaren
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Datenschutz;